import script from "./BASE.vue?vue&type=script&setup=true&lang=ts"
export * from "./BASE.vue?vue&type=script&setup=true&lang=ts"

import "./BASE.vue?vue&type=style&index=0&id=2c6909d4&scoped=true&lang=css"
import "./BASE.vue?vue&type=style&index=1&id=2c6909d4&lang=css"
import "./BASE.vue?vue&type=style&index=2&id=2c6909d4&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6909d4"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QSpace,QBtn,QIcon,QMenu,QList,QItem,QItemSection,QSeparator,QPageContainer,QDrawer,QScrollArea,QDialog,QCard,QToolbar,QAvatar,QToolbarTitle,QCardSection,QCardActions});
